import type { MetaFunction } from 'react-router';

import { canonicalTag } from '@jane/bloom/resources/meta/canonicalTag';
import { createMetaVariables } from '@jane/bloom/resources/meta/createMetaVariables';
import { getMetaDescription } from '@jane/bloom/resources/meta/description';
import { getRootLoaderData } from '@jane/bloom/resources/meta/getRootLoaderData';
import { openGraph } from '@jane/bloom/resources/meta/openGraph';
import { parentMeta } from '@jane/bloom/resources/meta/parentMeta';
import { preloadImage } from '@jane/bloom/resources/meta/preloadImage';
import { productStructuredData } from '@jane/bloom/resources/meta/product';
import { getMetaTitle } from '@jane/bloom/resources/meta/title';
import type { loader } from '@jane/bloom/routes/$basename.products.$productId.$slug/route';

const DEFAULT_TITLE =
  'Shop {{ productName }} | {{ storeName }} Dispensary {{ storeCity }}, {{ storeStateAbbr }}';
const DEFAULT_DESCRIPTION = `Visit {{ storeName }} dispensary in {{ storeCity }}, {{ storeStateAbbr }} and order {{ storeFulfillment }} cannabis online products for {{ storeType }}. Browse our online dispensary menu for flower, edibles, vape and more.`;

export const pdpRouteMeta: MetaFunction<typeof loader> = (args) => {
  const { customSEO, menuUrl, metaProps } = getRootLoaderData(args);
  const data = args.loaderData;

  const pdpViewModel = data?.productDetail;
  const image = pdpViewModel?.productImagesSrcSets?.[0] ?? null;

  // Match metaProps to available customSEO variables
  const metaVariables = createMetaVariables(metaProps, {
    productBrand: pdpViewModel?.product.brand,
    productCategory: pdpViewModel?.product.kind,
    productLineage: pdpViewModel?.product.category,
    productName: pdpViewModel?.product.name,
    productSubcategory: pdpViewModel?.product.root_subtype,
  });

  return [
    getMetaTitle(customSEO?.pdp ?? {}, metaVariables, DEFAULT_TITLE),
    getMetaDescription(
      customSEO?.pdp ?? {},
      metaVariables,
      DEFAULT_DESCRIPTION
    ),
    canonicalTag(args.location, menuUrl),
    productStructuredData(
      pdpViewModel?.product,
      data?.pinnedStore?.currencyCode
    ),
    openGraph(pdpViewModel?.product),
    preloadImage({
      sizes: image?.sizes,
      src: image?.fallbackSrc,
      srcSet: image?.srcSet,
    }),
    ...parentMeta(args),
  ];
};
